import { AppState } from '../../../interfaces';
import { connect } from 'react-redux';
import Thankyou from './Thankyou';
import { generalData } from '../../../actions/general';
const mapStateToProps = (state: AppState) => ({
  page: state.freeProductsReducer,
  generalData: state.appReducer,
  app: state.appReducer,
});

const mapDispatchToProps = (dispatch) => ({
  generalData: () => dispatch(generalData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Thankyou);
